import { lazy, Suspense } from 'react';
import type { OsmMapPickerProps } from './OsmMapPicker';

export type { OsmMapBbox, OsmMapPickerProps } from './OsmMapPicker';

const Loaded = lazy(() =>
  import('./OsmMapPicker').then((module) => ({ default: module.OsmMapPicker })),
);

/** `OsmMapPicker`, with Leaflet and its styles downloaded only when a map is rendered. */
export function LazyOsmMapPicker(props: OsmMapPickerProps) {
  return (
    <Suspense
      fallback={
        <div
          style={{ height: props.height ?? 300 }}
          className="w-full animate-pulse bg-surface-2"
        />
      }
    >
      <Loaded {...props} />
    </Suspense>
  );
}
